const isDate = require('date-and-time')
const cleanArray = function (array) {
  var i
  var j
  var len = array.length
  var out = []
  var obj = {}
  for (i = 0; i < len; i++) {
    obj[array[i]] = 0
  }
  for (j in obj) {
    out.push(j)
  }
  return out
}

const searchColumn = function (array) {
  var columnValues = []

  for (let index = 0; index < array.length; index++) {
    columnValues.push(array[index].column)
  }
  return columnValues
}

const buildColumn = function (array) {
  var column = ''
  for (var i = 0; i < array.length; i++) {
    if (i === 0) {
      column = array[i]
    } else {
      column = array[i] + ', ' + column
    }
  }
  return column
}

const buildNbrLine = function (array) {
  var column = ''
  for (var i = 0; i < array.length; i++) {
    if (i === 0) {
      column = array[i].nbrLine
    } else {
      column = array[i].nbrLine + ', ' + column
    }
  }
  return column
}

const dateFormater = function (newDate) {
  if (isDate.isValid(newDate, 'DD/MM/YYYY')) {
    return newDate
  } else if (isDate.isValid(newDate, 'DDMMYY')) {
    newDate =
      newDate[0] +
      newDate[1] +
      '/' +
      newDate[2] +
      newDate[3] +
      '/' +
      '20' +
      newDate[4] +
      newDate[5]
    return newDate
  } else if (isDate.isValid(newDate, 'DD-MM-YYYY')) {
    newDate =
      newDate.split('-')[0] +
      '/' +
      newDate.split('-')[1] +
      '/' +
      newDate.split('-')[2]
    return newDate
  } else if (isDate.isValid(newDate, 'YYYY-MM-DD')) {
    newDate =
      newDate.split('-')[2] +
      '/' +
      newDate.split('-')[1] +
      '/' +
      newDate.split('-')[0]
    return newDate
  } else if (isDate.isValid(newDate, 'YY/MM/DD')) {
    newDate =
      '0' +
      newDate.split('/')[0] +
      '/' +
      newDate.split('/')[1] +
      '/' +
      '20' +
      newDate.split('/')[2]
    return newDate
  } else if (isDate.isValid(newDate, 'YYYY/MM/DD')) {
    newDate =
      newDate.split('/')[2] +
      '/' +
      newDate.split('/')[1] +
      '/' +
      newDate.split('/')[0]
    return newDate
  } else if (isDate.isValid(newDate, 'DD/MM/YY')) {
    newDate =
      newDate.split('/')[0] +
      '/' +
      newDate.split('/')[1] +
      '/' +
      '20' +
      newDate.split('/')[2]
    return newDate
  } else if (isDate.isValid(newDate, 'MM/DD/YY')) {
    newDate =
      newDate.split('/')[1] +
      '/' +
      newDate.split('/')[0] +
      '/' +
      '20' +
      newDate.split('/')[2]
    return newDate
  } else if (isDate.isValid(newDate, 'M/DD/YY')) {
    newDate =
      newDate.split('/')[1] +
      '/' +
      '0' +
      newDate.split('/')[0] +
      '/' +
      '20' +
      newDate.split('/')[2]
    return newDate
  } else if (isDate.isValid(newDate, 'M/D/YY')) {
    newDate =
      '0' +
      newDate.split('/')[1] +
      '/' +
      '0' +
      newDate.split('/')[0] +
      '/' +
      '20' +
      newDate.split('/')[2]
    return newDate
  } else {
    return newDate
  }
}

const checkDate = function (dateTocheck) {
  if (isDate.isValid(dateTocheck, 'DD/MM/YYYY')) {
    return true
  } else {
    return false
  }
}

const isNumber = function (number) {
  if (typeof number === 'number') {
    return true
  } else {
    return false
  }
}

module.exports = {
  cleanArray: cleanArray,
  searchColumn: searchColumn,
  buildColumn: buildColumn,
  buildNbrLine: buildNbrLine,
  dateFormater: dateFormater,
  checkDate: checkDate,
  isNumber: isNumber
}
